import { FleekError } from './FleekError';

type UserHasNoAccessToAnotherUserErrorOptions = Record<string, never>;

export class UserHasNoAccessToAnotherUserError extends FleekError<UserHasNoAccessToAnotherUserErrorOptions> {
  public name = 'UserHasNoAccessToAnotherUserError';

  constructor() {
    super({});
  }

  toString = () => 'You don`t have access to user you try to fetch data for.';
}
